import { useEffect, useState } from "react"

import { DetectCountryDocument, type DetectCountryQuery } from "../generated/graphql"
import { graphQLClient } from "../graphql/client"

const useCountryCodeByIP = () => {
  const [countryCode, setCountryCode] = useState("")

  useEffect(() => {
    const detect = async () => {
      try {
        const data = await graphQLClient.request<DetectCountryQuery>(DetectCountryDocument)
        if (data.detectCountry) {
          setCountryCode(data.detectCountry)
        }
      } catch {
        // Silently ignore - country detection is non-critical
      }
    }
    void detect()
  }, [])

  return countryCode
}

export default useCountryCodeByIP
